import React, { Suspense, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { CSpinner, useColorModes } from "@coreui/react";
import "./scss/style.scss";
import "./style.css";
import RouteManager from "./routes";

const App = () => {
  const { setColorMode, colorMode } = useColorModes(
    "coreui-free-react-admin-template-theme"
  );
  // console.log = console.warn = console.error = () => {}; // Disable all console methods in production
  useEffect(() => {
    if (colorMode !== "light") {
      setColorMode("light");
    }
  }, []);

  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      >
        <RouteManager />
      </Suspense>
    </BrowserRouter>
  );
};

export default App;
